const fromOutgrow = window.location.pathname === "/outgrow";

export default function getEnv() {
  switch (window.location.hostname) {
    case "localhost":
      return {
        ENVIRONMENT: "development",
        isAI: false,
        SERVER_API_URL:
          import.meta.env.VITE_SERVER_API_URL || "http://localhost:4000",
        LIVEBOT_URL: "http://localhost:3001",
        PUBLIC_DOMAIN: "localhost",
        PAGE_DOMAIN: "localhost",
        PUBLIC_GOOGLE_APP_ID:
          "533552806890-nqbc119bn07u8th8t0b9r9j96oj1igtb.apps.googleusercontent.com",
        PUBLIC_GOOGLE_CLIENT_ID:
          "1095766540075-um298usg18v4nm60fmssg2angr2sbib2.apps.googleusercontent.com",
        AUTH_FACEBOOK_APP_ID: 1093472884694695, //old OMNI login app
        PUBLIC_FACEBOOK_APP_ID: 1093472884694695,
        PUBLIC_INSTAGRAM_APP_ID: 452688490508976,
        PUBLIC_WHATSAPP_APP_ID: 1110401781129740,
        FILESTACK_API_KEY: "A3ygIw4hISSCdApqW4SAwz",
        TIMEKIT_API_KEY: "test_widget_key_fjjvV6bPF8uCze6j3qJGMfbmBemvdPKf",
        TIMEKIT_PROJECT_ID: "d319cfec-7618-4765-abf5-fac8c9381192",
        META_API_VERSION: "v19.0",
        GOOGLE_PICKER_DEVELOPER_KEY: "AIzaSyATCIhPWX9AGuJygK1she7fq5aEUVUwNso",
        STRIPE_PUBLIC_KEY:
          "pk_test_51LDGaqAMQsTGGiHorKcAtUMskM5BOr2ycwMnLkpkOA2OprA618Q9ifCzblBI5bHzDymRuTQkmMDBGN09uKuFrCQs00p2zXDibJ",
        META_CONFIGS: {
          login: "883317163601799",
          pages: "1528923587675165", // FB pages
          whatsapp: "2357118394498759", // WA business account
        },
        RECAPTCHAKEY: "6Lcj1DMqAAAAAAn7Y6wSnsVzu2Uq_cjvu_CY84Zs",
        HCAPTCHAKEY: "9f7854b4-a918-42c2-986e-ac665a9a7930",
        OUTLOOK_CLIENT_ID: "979c9342-67f3-4831-94f9-877f8013b90a",
        MONTHLYPLAN: "price_1PUNgrAMQsTGGiHo3P1Nmb3A",
        YEARLYPLAN: "price_1QHi66AMQsTGGiHosqx4P3fs",
        TRIALPLAN: "price_1PUNnQAMQsTGGiHockGBkgWA",
        LIFETIMEOMNI1: "price_1Prdz1AMQsTGGiHofHPyHq8O",
        LIFETIMEOMNI2: "price_1PreHcAMQsTGGiHouvvXYpmV",
        LIFETIMECBB1: "price_1RSyn2Fas3GhAJRi19EPjcTq",
        LIFETIMECBB2: "price_1ReAhvFas3GhAJRi2OTqdnYf",
        LIFETIMECBB3: "price_1RSynVFas3GhAJRiClEKvSaw",
        LIFETIMECBB4: "price_1RutuGFas3GhAJRiM2nwhF9F",
        SALESFORCE_CLIENT_ID:
          "3MVG9YDQS5WtC11rKOoecjsTdHqB.HVHb53M2jFbHbeXZ7xcfZXd7KqR.CQ0d3aKDuJel1YkR8O0h743N5JA2",
        CALENDLY_CLIENT_ID: "lzA_YpcK3FgT2-dhV3i8hPrDqZ825ApuxfgQdeEAPhI",
        INTERCOM_CLIENT_ID: "7d532053-5984-4ce8-bfb2-4efd884f75e5",
        ZENDESK_CLIENT_ID: "chatbotbuilder-dev",
        ZENDESK_AUTH_URL:
          "https://mango8656.zendesk.com/oauth/authorizations/new",
        CRISP_CLIENT_ID: "",
      };
    case "ai.localhost":
      return {
        ENVIRONMENT: "development",
        isAI: true,
        SERVER_API_URL:
          import.meta.env.VITE_SERVER_API_URL || "http://localhost:4000",
        LIVEBOT_URL: "http://ai.localhost:3001",
        PUBLIC_DOMAIN: "ai.localhost",
        PAGE_DOMAIN: "ai.localhost",
        PUBLIC_GOOGLE_APP_ID:
          "533552806890-nqbc119bn07u8th8t0b9r9j96oj1igtb.apps.googleusercontent.com",
        PUBLIC_GOOGLE_CLIENT_ID:
          "1095766540075-um298usg18v4nm60fmssg2angr2sbib2.apps.googleusercontent.com",
        GOOGLE_PICKER_DEVELOPER_KEY: "AIzaSyATCIhPWX9AGuJygK1she7fq5aEUVUwNso",
        AUTH_FACEBOOK_APP_ID: 956127348390513, //old cbb login app
        PUBLIC_FACEBOOK_APP_ID: 2106755656362298,
        PUBLIC_INSTAGRAM_APP_ID: 452688490508976,
        PUBLIC_WHATSAPP_APP_ID: 2106755656362298,
        FILESTACK_API_KEY: "A3ygIw4hISSCdApqW4SAwz", //local jp API key
        TIMEKIT_API_KEY: "test_widget_key_fjjvV6bPF8uCze6j3qJGMfbmBemvdPKf",
        TIMEKIT_PROJECT_ID: "d319cfec-7618-4765-abf5-fac8c9381192",
        META_API_VERSION: "v19.0",
        META_CONFIGS: {
          login: "883317163601799",
          pages: "1528923587675165", // FB pages
          whatsapp: "2357118394498759", // WA business account
        },
        RECAPTCHAKEY: "6Lcj1DMqAAAAAAn7Y6wSnsVzu2Uq_cjvu_CY84Zs",
        HCAPTCHAKEY: "9f7854b4-a918-42c2-986e-ac665a9a7930",
        OUTLOOK_CLIENT_ID: "979c9342-67f3-4831-94f9-877f8013b90a",
        STRIPE_PUBLIC_KEY:
          "pk_test_51LMK5oFas3GhAJRiv9K19NjmkoXHIXgzGdTuK4XSkKRFxJrKklXiKJ65tg2s3MXIEBbPnjE3K131pNLXcj39pxLR00qA7RU3Zk",
        MONTHLYPLAN: "price_1PXd6cFas3GhAJRiDsUXqkT8",
        YEARLYPLAN: "price_1QHOicFas3GhAJRirCygOqgQ",
        MONTHLYPLAN_PROFESSIONAL: "price_1PXd7jFas3GhAJRiF111LQdI",
        YEARLYPLAN_PROFESSIONAL: "price_1QHOQdFas3GhAJRidTJP8vl2",
        TRIALPLAN: "price_1PXd5LFas3GhAJRi3AtOqvUS",
        LIFETIMEOMNI1: "price_1Prdz1AMQsTGGiHofHPyHq8O",
        LIFETIMEOMNI2: "price_1PreHcAMQsTGGiHouvvXYpmV",
        LIFETIMECBB1: "price_1S0L8HFas3GhAJRilbGiA4Mj",
        LIFETIMECBB2: "price_1S0L9UFas3GhAJRi0X9Gs0Z7",
        LIFETIMECBB3: "price_1Rm92OFas3GhAJRiwdMQvZA7",
        LIFETIMECBB4: "price_1RutuGFas3GhAJRiM2nwhF9F",
        LIFETIMECBBOLD1: "price_1RSyn2Fas3GhAJRi19EPjcTq",
        LIFETIMECBBOLD2: "price_1RSynVFas3GhAJRiClEKvSaw",
        SALESFORCE_CLIENT_ID:
          "3MVG9YDQS5WtC11rKOoecjsTdHqB.HVHb53M2jFbHbeXZ7xcfZXd7KqR.CQ0d3aKDuJel1YkR8O0h743N5JA2",
        NOTION_CLIENT_ID: "128d872b-594c-80b5-94de-00374f66ae4c",
        CONFLUENCE_CLIENT_ID: "3UcrhP9S9V9hbPN6kd2EX9dND7twMlwN",
        CALENDLY_CLIENT_ID: "pIz1FgXp1RzMbgQtImmL8RtRilkNIrTT2wpWd098oXI", //use localhost only for running calendly
        INTERCOM_CLIENT_ID: "7d532053-5984-4ce8-bfb2-4efd884f75e5",
        ZENDESK_CLIENT_ID: "chatbotbuilder",
        ZENDESK_AUTH_URL:
          "https://mango8656.zendesk.com/oauth/authorizations/new",
        CRISP_CLIENT_ID: "",
      };
    case "app.outgrow.chat":
      return {
        ENVIRONMENT: "staging",
        isAI: false,
        SERVER_API_URL: "https://api.outgrow.chat",
        PUBLIC_DOMAIN: "app.outgrow.chat",
        PAGE_DOMAIN: "app.outgrow.chat",
        PUBLIC_GOOGLE_APP_ID:
          "825285028982-ejjvllvr0aid7dnit7ca9aib01b25slt.apps.googleusercontent.com",
        GOOGLE_PICKER_DEVELOPER_KEY: "AIzaSyATCIhPWX9AGuJygK1she7fq5aEUVUwNso",
        AUTH_FACEBOOK_APP_ID: 956127348390513, //old OMNI login ap
        PUBLIC_FACEBOOK_APP_ID: 1093472884694695,
        PUBLIC_INSTAGRAM_APP_ID: 709230208331033,
        PUBLIC_WHATSAPP_APP_ID: 2106755656362298,
        FILESTACK_API_KEY: "A3ygIw4hISSCdApqW4SAwz",
        LIVEBOT_URL: "https://live.outgrow.chat",
        TIMEKIT_API_KEY: "test_widget_key_fjjvV6bPF8uCze6j3qJGMfbmBemvdPKf",
        TIMEKIT_PROJECT_ID: "d319cfec-7618-4765-abf5-fac8c9381192",
        META_API_VERSION: "v19.0",
        OUTLOOK_CLIENT_ID: "f92fa805-06aa-48b6-90bb-384f5a2bc7f8",
        RECAPTCHAKEY: "6Lcj1DMqAAAAAAn7Y6wSnsVzu2Uq_cjvu_CY84Zs",
        HCAPTCHAKEY: "9f7854b4-a918-42c2-986e-ac665a9a7930",
        STRIPE_PUBLIC_KEY:
          "pk_test_51LDGaqAMQsTGGiHorKcAtUMskM5BOr2ycwMnLkpkOA2OprA618Q9ifCzblBI5bHzDymRuTQkmMDBGN09uKuFrCQs00p2zXDibJ",
        MONTHLYPLAN: "price_1PUNgrAMQsTGGiHo3P1Nmb3A",
        YEARLYPLAN: "price_1QHi66AMQsTGGiHosqx4P3fs",
        LIFETIMEOMNI1: "price_1Prdz1AMQsTGGiHofHPyHq8O",
        LIFETIMEOMNI2: "price_1PreHcAMQsTGGiHouvvXYpmV",
        LIFETIMECBB1: "price_1S0L8HFas3GhAJRilbGiA4Mj",
        LIFETIMECBB2: "price_1S0L9UFas3GhAJRi0X9Gs0Z7",
        LIFETIMECBB3: "price_1Rm92OFas3GhAJRiwdMQvZA7",
        LIFETIMECBB4: "price_1RutuGFas3GhAJRiM2nwhF9F",
        LIFETIMECBBOLD1: "price_1RSyn2Fas3GhAJRi19EPjcTq",
        LIFETIMECBBOLD2: "price_1RSynVFas3GhAJRiClEKvSaw",
        TRIALPLAN: "price_1PUNnQAMQsTGGiHockGBkgWA",
        SALESFORCE_CLIENT_ID:
          "3MVG9YDQS5WtC11rKOoecjsTdHqB.HVHb53M2jFbHbeXZ7xcfZXd7KqR.CQ0d3aKDuJel1YkR8O0h743N5JA2",
        CALENDLY_CLIENT_ID: "",
        INTERCOM_CLIENT_ID: "7d532053-5984-4ce8-bfb2-4efd884f75e5",
        ZENDESK_CLIENT_ID: "",
        ZENDESK_AUTH_URL: "",
        CRISP_CLIENT_ID: "",
      };
    case "ai.outgrow.chat":
      return {
        ENVIRONMENT: "staging",
        isAI: true,
        SERVER_API_URL: "https://api.outgrow.chat",
        PUBLIC_DOMAIN: "ai.outgrow.chat",
        PAGE_DOMAIN: "ai.outgrow.chat",
        PUBLIC_GOOGLE_APP_ID:
          "825285028982-ejjvllvr0aid7dnit7ca9aib01b25slt.apps.googleusercontent.com",
        PUBLIC_GOOGLE_CLIENT_ID:
          "147089289192-c7es9gc449g8obgl5ug5b8d8anlu5nms.apps.googleusercontent.com",
        GOOGLE_PICKER_DEVELOPER_KEY: "AIzaSyATCIhPWX9AGuJygK1she7fq5aEUVUwNso",
        AUTH_FACEBOOK_APP_ID: 730920289667613, //1093472884694695,  //old cbb login app
        PUBLIC_FACEBOOK_APP_ID: 730920289667613, //1093472884694695, //old cbb integration app
        PUBLIC_INSTAGRAM_APP_ID: 1171486044999455, //  cbb integration test app insta
        PUBLIC_WHATSAPP_APP_ID: 1518711735799247, // new cbb, integration app insta
        RECAPTCHAKEY: "6Lcj1DMqAAAAAAn7Y6wSnsVzu2Uq_cjvu_CY84Zs",
        HCAPTCHAKEY: "9f7854b4-a918-42c2-986e-ac665a9a7930",
        FILESTACK_API_KEY: "A3ygIw4hISSCdApqW4SAwz",
        LIVEBOT_URL: "https://liveai.outgrow.chat",
        TIMEKIT_API_KEY: "test_widget_key_fjjvV6bPF8uCze6j3qJGMfbmBemvdPKf",
        TIMEKIT_PROJECT_ID: "83d6c352-cd2a-4c84-8efe-12667c2a4d29",
        META_API_VERSION: "v19.0",
        OUTLOOK_CLIENT_ID: "f92fa805-06aa-48b6-90bb-384f5a2bc7f8",
        STRIPE_PUBLIC_KEY:
          "pk_test_51LMK5oFas3GhAJRiv9K19NjmkoXHIXgzGdTuK4XSkKRFxJrKklXiKJ65tg2s3MXIEBbPnjE3K131pNLXcj39pxLR00qA7RU3Zk",
        MONTHLYPLAN: "price_1PXd6cFas3GhAJRiDsUXqkT8",
        YEARLYPLAN: "price_1QHOicFas3GhAJRirCygOqgQ",
        MONTHLYPLAN_PROFESSIONAL: "price_1PXd7jFas3GhAJRiF111LQdI",
        YEARLYPLAN_PROFESSIONAL: "price_1QHOQdFas3GhAJRidTJP8vl2",
        TRIALPLAN: "price_1PXd5LFas3GhAJRi3AtOqvUS",
        LIFETIMEOMNI1: "price_1Prdz1AMQsTGGiHofHPyHq8O",
        LIFETIMEOMNI2: "price_1PreHcAMQsTGGiHouvvXYpmV",
        LIFETIMECBB1: "price_1T96WMFas3GhAJRiiZQoVNck",
        LIFETIMECBB2: "price_1T96WxFas3GhAJRisRjIzfb9",
        LIFETIMECBB3: "price_1T96txFas3GhAJRieBvlQKyx",
        LIFETIMECBB4: "price_1T96ueFas3GhAJRitIZh8tNb",
        LIFETIMECBBOLD1: "price_1RSyn2Fas3GhAJRi19EPjcTq",
        LIFETIMECBBOLD2: "price_1RSynVFas3GhAJRiClEKvSaw",
        SALESFORCE_CLIENT_ID:
          "3MVG9YDQS5WtC11rKOoecjsTdHqB.HVHb53M2jFbHbeXZ7xcfZXd7KqR.CQ0d3aKDuJel1YkR8O0h743N5JA2",
        CALENDLY_CLIENT_ID: "pIz1FgXp1RzMbgQtImmL8RtRilkNIrTT2wpWd098oXI",
        NOTION_CLIENT_ID: "128d872b-594c-80b5-94de-00374f66ae4c",
        CONFLUENCE_CLIENT_ID: "3UcrhP9S9V9hbPN6kd2EX9dND7twMlwN",
        INTERCOM_CLIENT_ID: "7d532053-5984-4ce8-bfb2-4efd884f75e5",
        ZENDESK_CLIENT_ID: "chatbotbuilder-dev",
        ZENDESK_AUTH_URL:
          "https://mango8656.zendesk.com/oauth/authorizations/new",
        CRISP_CLIENT_ID: "",
      };
    case "release.outgrow.chat":
      return {
        ENVIRONMENT: "release",
        isAI: true,
        SERVER_API_URL: "https://api-release.outgrow.chat",
        PUBLIC_DOMAIN: "release.outgrow.chat",
        PAGE_DOMAIN: "release.outgrow.chat",
        PUBLIC_GOOGLE_APP_ID:
          "749898743140-rmofpdeu4kpjiihna1j0knhe179c7m6f.apps.googleusercontent.com",
        PUBLIC_GOOGLE_CLIENT_ID:
          "1095766540075-um298usg18v4nm60fmssg2angr2sbib2.apps.googleusercontent.com",
        GOOGLE_PICKER_DEVELOPER_KEY: "AIzaSyATCIhPWX9AGuJygK1she7fq5aEUVUwNso",
        AUTH_FACEBOOK_APP_ID: 956127348390513, //old cbb login ap
        PUBLIC_FACEBOOK_APP_ID: 956127348390513, //old cbb integration app
        PUBLIC_INSTAGRAM_APP_ID: 1171486044999455, //new cbb integration app insta
        PUBLIC_WHATSAPP_APP_ID: 1110401781129740, //new cbb integration app insta
        FILESTACK_API_KEY: "A3ygIw4hISSCdApqW4SAwz",
        LIFETIMEOMNI1: "price_1PuYvoAMQsTGGiHopqQP8rbA",
        LIFETIMEOMNI2: "price_1PuYvrAMQsTGGiHoqHEC62Rf",
        LIFETIMECBB1: "price_1S0JycFas3GhAJRizXoeefTx",
        LIFETIMECBB2: "price_1S0JzDFas3GhAJRiZEzOjWVa",
        LIFETIMECBBOLD1: "price_1ReAhHFas3GhAJRiZvH04Fhm",
        LIFETIMECBBOLD2: "price_1ReAhvFas3GhAJRi2OTqdnYf",
        LIFETIMECBB3: "price_1Rm92OFas3GhAJRiwdMQvZA7",
        LIFETIMECBB4: "price_1RutizFas3GhAJRitpYK569P",
        RECAPTCHAKEY: "6LdhMVMqAAAAAApDW0lI1XlFGVPd-6J8qxtzAya9",
        HCAPTCHAKEY: "f80a1346-0434-429c-b31c-b0869d9812f6",
        LIVEBOT_URL: "https://live-release.outgrow.chat",
        TIMEKIT_API_KEY: "live_widget_key_XLsFIuOL345Gwtef0OQRcMYeNfjqAsYe", // OG KEy
        TIMEKIT_PROJECT_ID: "c7fa7704-7a34-4bc6-824f-9b2a2af62630", // chatBot
        META_API_VERSION: "v19.0",
        OUTLOOK_CLIENT_ID: "979c9342-67f3-4831-94f9-877f8013b90a",
        STRIPE_PUBLIC_KEY:
          "pk_live_51LMK5oFas3GhAJRiwyHa2yRixlsElEgVtTdzEHJewj5IsXqzXs9H2G4XFVlgOVCHUcPqlKupy9xKhVVYdALXP0dW001w1n7F8a",
        MONTHLYPLAN: "price_1PTi7HFas3GhAJRiE6wlhc1L",
        YEARLYPLAN: "price_1QHjbrFas3GhAJRiUJBVs3cj",
        MONTHLYPLAN_PROFESSIONAL: "price_1PaxxUFas3GhAJRiSfZNXsjW",
        YEARLYPLAN_PROFESSIONAL: "price_1QHjbwFas3GhAJRiKcATfgcI",
        TRIALPLAN: "price_1PaxwjFas3GhAJRiocA8j7Yj",
        SALESFORCE_CLIENT_ID:
          "3MVG9YDQS5WtC11rKOoecjsTdHqB.HVHb53M2jFbHbeXZ7xcfZXd7KqR.CQ0d3aKDuJel1YkR8O0h743N5JA2",
        NOTION_CLIENT_ID: "13bd872b-594c-80bf-b1cb-00376c236f32",
        CALENDLY_CLIENT_ID: "113kuFMOpR8NY1JRrn1PMTMakkItplM7LLVnPY3za3I",
        CONFLUENCE_CLIENT_ID: "AQbhkOOuKqg0iaxJBD7Awmg8lwQIXeca",
        INTERCOM_CLIENT_ID: "ca427f7d-a092-43c2-90c4-0ffca4652c48",
        ZENDESK_CLIENT_ID: "chatbotbuilder",
        ZENDESK_AUTH_URL:
          "https://omniengagehelp.zendesk.com/oauth/authorizations/new",
        CRISP_CLIENT_ID: "",
      };
    case "app.omniengage.co":
      return {
        ENVIRONMENT: "production",
        isAI: false,
        SERVER_API_URL: "https://api.omniengage.co",
        PUBLIC_DOMAIN: "app.omniengage.co",
        PAGE_DOMAIN: "omniengage.co",
        PUBLIC_GOOGLE_APP_ID:
          "749898743140-rmofpdeu4kpjiihna1j0knhe179c7m6f.apps.googleusercontent.com",
        GOOGLE_PICKER_DEVELOPER_KEY: "AIzaSyATCIhPWX9AGuJygK1she7fq5aEUVUwNso",
        AUTH_FACEBOOK_APP_ID: 1093472884694695, //old OMNI login ap
        PUBLIC_FACEBOOK_APP_ID: 1093472884694695,
        PUBLIC_INSTAGRAM_APP_ID: 452688490508976,
        PUBLIC_WHATSAPP_APP_ID: 2106755656362298,
        FILESTACK_API_KEY: "A3ygIw4hISSCdApqW4SAwz",
        RECAPTCHAKEY: "6Lf4NDgqAAAAALbxk3ZhEjoYkNvEswfuIQaq4eX1",
        HCAPTCHAKEY: "dd744e5e-b8ba-4aae-a70e-354e6e30be02",
        LIVEBOT_URL: "https://<sub-domain>.omniengage.co",
        TIMEKIT_API_KEY: "live_widget_key_XLsFIuOL345Gwtef0OQRcMYeNfjqAsYe", // OG key
        TIMEKIT_PROJECT_ID: "a0aa96e2-d35c-476b-95ed-790c648e8453", // omni
        META_API_VERSION: "v19.0",
        OUTLOOK_CLIENT_ID: "979c9342-67f3-4831-94f9-877f8013b90a",
        LIFETIMEOMNI1: "price_1PuYvoAMQsTGGiHopqQP8rbA",
        LIFETIMEOMNI2: "price_1PuYvrAMQsTGGiHoqHEC62Rf",
        LIFETIMECBB1: "price_1RSxvRFas3GhAJRiin1Jx0pJ",
        LIFETIMECBB2: "price_1RSxu7Fas3GhAJRixngj8cnD",
        LIFETIMECBB3: "price_1Rm92OFas3GhAJRiwdMQvZA7",
        LIFETIMECBB4: "price_1RutizFas3GhAJRitpYK569P",
        MONTHLYPLAN: "price_1PUO77AMQsTGGiHo9aJ4kKk9",
        YEARLYPLAN: "price_1QHjZZAMQsTGGiHo3OKnQ9if",
        TRIALPLAN: "price_1PUO9WAMQsTGGiHoHFwmjojN",
        STRIPE_PUBLIC_KEY:
          "pk_live_51LDGaqAMQsTGGiHoxsGviZI53uKvzgMa6cinvyozi9JSVzVqLIuWpo5RqlSIzukKjUTRwJP5LOnGBwjenK7IGRxT00L6zOJlHO",
        SALESFORCE_CLIENT_ID:
          "3MVG9YDQS5WtC11rKOoecjsTdHqB.HVHb53M2jFbHbeXZ7xcfZXd7KqR.CQ0d3aKDuJel1YkR8O0h743N5JA2",
        CALENDLY_CLIENT_ID: "",
        INTERCOM_CLIENT_ID: "",
        ZENDESK_CLIENT_ID: "",
        ZENDESK_AUTH_URL: "",
        CRISP_CLIENT_ID: "",
      };
    case "app.chatbotbuilder.net":
      return {
        ENVIRONMENT: "production",
        isAI: true,
        SERVER_API_URL: fromOutgrow
          ? "https://live-api.outgrow.chat"
          : "https://api.chatbotbuilder.net",
        PUBLIC_DOMAIN: "app.chatbotbuilder.net",
        PAGE_DOMAIN: "chatbotbuilder.net",
        PUBLIC_GOOGLE_APP_ID:
          "749898743140-rmofpdeu4kpjiihna1j0knhe179c7m6f.apps.googleusercontent.com",
        PUBLIC_GOOGLE_CLIENT_ID:
          "1095766540075-um298usg18v4nm60fmssg2angr2sbib2.apps.googleusercontent.com",
        GOOGLE_PICKER_DEVELOPER_KEY: "AIzaSyATCIhPWX9AGuJygK1she7fq5aEUVUwNso",
        AUTH_FACEBOOK_APP_ID: 956127348390513, //old cbb login ap
        PUBLIC_FACEBOOK_APP_ID: 956127348390513, //old cbb integration app
        PUBLIC_INSTAGRAM_APP_ID: 709230208331033, //new cbb integration app insta
        PUBLIC_WHATSAPP_APP_ID: 1110401781129740, //new cbb integration app insta
        FILESTACK_API_KEY: "A3ygIw4hISSCdApqW4SAwz",
        LIFETIMEOMNI1: "price_1PuYvoAMQsTGGiHopqQP8rbA",
        LIFETIMEOMNI2: "price_1PuYvrAMQsTGGiHoqHEC62Rf",
        LIFETIMECBB1: "price_1S0JycFas3GhAJRizXoeefTx",
        LIFETIMECBB2: "price_1S0JzDFas3GhAJRiZEzOjWVa",
        LIFETIMECBBOLD1: "price_1ReAhHFas3GhAJRiZvH04Fhm",
        LIFETIMECBBOLD2: "price_1ReAhvFas3GhAJRi2OTqdnYf",
        LIFETIMECBB3: "price_1Rm94CFas3GhAJRiJBHXg0pV",
        LIFETIMECBB4: "price_1RutizFas3GhAJRitpYK569P",
        RECAPTCHAKEY: "6LdhMVMqAAAAAApDW0lI1XlFGVPd-6J8qxtzAya9",
        HCAPTCHAKEY: "f80a1346-0434-429c-b31c-b0869d9812f6",
        LIVEBOT_URL: "https://<sub-domain>.chatbotbuilder.net",
        TIMEKIT_API_KEY: "live_widget_key_XLsFIuOL345Gwtef0OQRcMYeNfjqAsYe", // OG KEy
        TIMEKIT_PROJECT_ID: "c7fa7704-7a34-4bc6-824f-9b2a2af62630", // chatBot
        META_API_VERSION: "v19.0",
        OUTLOOK_CLIENT_ID: "979c9342-67f3-4831-94f9-877f8013b90a",
        STRIPE_PUBLIC_KEY:
          "pk_live_51LMK5oFas3GhAJRiwyHa2yRixlsElEgVtTdzEHJewj5IsXqzXs9H2G4XFVlgOVCHUcPqlKupy9xKhVVYdALXP0dW001w1n7F8a",
        MONTHLYPLAN: "price_1PTi7HFas3GhAJRiE6wlhc1L",
        YEARLYPLAN: "price_1QHjbrFas3GhAJRiUJBVs3cj",
        MONTHLYPLAN_PROFESSIONAL: "price_1PaxxUFas3GhAJRiSfZNXsjW",
        YEARLYPLAN_PROFESSIONAL: "price_1QHjbwFas3GhAJRiKcATfgcI",
        TRIALPLAN: "price_1PaxwjFas3GhAJRiocA8j7Yj",
        SALESFORCE_CLIENT_ID:
          "3MVG9YDQS5WtC11rKOoecjsTdHqB.HVHb53M2jFbHbeXZ7xcfZXd7KqR.CQ0d3aKDuJel1YkR8O0h743N5JA2",
        NOTION_CLIENT_ID: "13bd872b-594c-80bf-b1cb-00376c236f32",
        CALENDLY_CLIENT_ID: "113kuFMOpR8NY1JRrn1PMTMakkItplM7LLVnPY3za3I",
        CONFLUENCE_CLIENT_ID: "AQbhkOOuKqg0iaxJBD7Awmg8lwQIXeca",
        INTERCOM_CLIENT_ID: "ca427f7d-a092-43c2-90c4-0ffca4652c48",
        ZENDESK_CLIENT_ID: "chatbotbuilder",
        ZENDESK_AUTH_URL:
          "https://omniengagehelp.zendesk.com/oauth/authorizations/new",
        CRISP_CLIENT_ID: "",
      };
    default:
      throw new Error("Invalid environment");
  }
}
